/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';

/**
 * Representation of a Future Stock
 * @export
 * @interface FutureStock
 */
export interface FutureStock {
    /**
     * 
     * @type {Stock}
     * @memberof FutureStock
     */
    stock?: Stock;
    /**
     * Date of future stock
     * @type {Date}
     * @memberof FutureStock
     */
    date?: Date;
    /**
     * Date of future stock expressed in text value
     * @type {string}
     * @memberof FutureStock
     */
    formattedDate?: string;
}

/**
 * Check if a given object implements the FutureStock interface.
 */
export function instanceOfFutureStock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FutureStockFromJSON(json: any): FutureStock {
    return FutureStockFromJSONTyped(json, false);
}

export function FutureStockFromJSONTyped(json: any, ignoreDiscriminator: boolean): FutureStock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stock': !exists(json, 'stock') ? undefined : StockFromJSON(json['stock']),
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'formattedDate': !exists(json, 'formattedDate') ? undefined : json['formattedDate'],
    };
}

export function FutureStockToJSON(value?: FutureStock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stock': StockToJSON(value.stock),
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'formattedDate': value.formattedDate,
    };
}

